import React, { FC } from 'react';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DeliveryScheduleFinishedFilter } from 'models/delivery-schedule';

type DeliveryScheduleStateFilterProps = {
    value: DeliveryScheduleFinishedFilter;
    onChange: (finishedFilter: DeliveryScheduleFinishedFilter) => void;
};

const STATE_OPTIONS: { value: DeliveryScheduleFinishedFilter; labelKey: string }[] = [
    { value: DeliveryScheduleFinishedFilter.NOT_FINISHED, labelKey: 'delivery-schedule:STATE_NOT_FINISHED' },
    { value: DeliveryScheduleFinishedFilter.FINISHED, labelKey: 'delivery-schedule:STATE_FINISHED' },
    { value: DeliveryScheduleFinishedFilter.BOTH, labelKey: 'delivery-schedule:STATE_BOTH' },
];

const DeliveryScheduleStateFilter: FC<DeliveryScheduleStateFilterProps> = ({
    value,
    onChange,
}: DeliveryScheduleStateFilterProps) => {
    const { t: translate } = useTranslation(['delivery-schedule']);

    return (
        <FormControl margin="dense" sx={{ minWidth: 180 }}>
            <InputLabel id="delivery-schedule-state-label">{translate('delivery-schedule:STATE')}</InputLabel>
            <Select
                labelId="delivery-schedule-state-label"
                id="delivery-schedule-state"
                label={translate('delivery-schedule:STATE')}
                value={value}
                onChange={(event: SelectChangeEvent) => onChange(event.target.value as DeliveryScheduleFinishedFilter)}
            >
                {STATE_OPTIONS.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {translate(option.labelKey)}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default DeliveryScheduleStateFilter;
